<!--This alert is manually closable and auto dismissable in 5 seconds-->
<template>
  <b-alert :variant="alertType" class="center-block" :show="dismissCountDown" dismissible @dismissed="dismissed" @dismiss-count-down="countDownChanged">{{ alertBody }}</b-alert>
</template>
<script>
export default {
  name: "AlertModal",
  props: {
    showAlert: Boolean
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0
    };
  },
  computed: {
    alertType() {
      return this.$store.getters["alert/variant"];
    },
    alertBody() {
      return this.$store.getters["alert/message"];
    }
  },
  methods: {
    dismissed() {
      this.dismissCountDown = 0;
      this.$store.dispatch("alert/hideAlert");
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  },
  mounted() {
    this.$props.showAlert ? this.countDownChanged(5) : this.countDownChanged(0);
  }
};
</script>
<style scoped>
/*overriding bootstarp alert css class to make the alert box to align center with width 80%*/
.alert {
  position: fixed;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 2px solid transparent;
  border-radius: 0.25rem;
  text-align: center;
  width: 80%;
  left: 0;
  right: 0;
  top: 1em;
  z-index: 1050;
  margin: auto;
}
</style>
